import type { FC } from 'react';
import { Box } from '@mui/material';
import type { SecondaryTitleProps } from './types';

export const SecondaryTitle: FC<SecondaryTitleProps> = ({ text, color }: SecondaryTitleProps) => {
    return <Box sx={{ color, fontWeight: 'bold', fontSize: '0.9rem' }}>{text}</Box>;
};
